import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "浏览器缓存文件通知",
    description:
      "我们使用必要的浏览器缓存文件来确保本网站正常运行。我们还使用可选的跟踪浏览器缓存文件，帮助我们了解您如何与网站交互。这些可选的文件仅在您同意的情况下才会被设置。",
    acceptAllBtn: "全部接受",
    acceptNecessaryBtn: "全部拒绝",
    showPreferencesBtn: "管理个人偏好",
  },
  preferencesModal: {
    title: "管理浏览器缓存文件偏好",
    acceptAllBtn: "全部接受",
    acceptNecessaryBtn: "全部拒绝",
    savePreferencesBtn: "接受当前选择",
    closeIconLabel: "关闭窗口",
    sections: [
      {
        title: "浏览器缓存文件使用情况",
        description:
          "我们使用浏览器缓存文件来支持本网站的基本功能，并提升您的浏览体验。",
      },
      {
        title: "严格必要的浏览器缓存文件",
        description:
          "这些浏览器缓存文件对于网站的正常运行至关重要，例如用户身份验证。",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "名称",
            domain: "服务",
            description: "描述",
            expiration: "到期时间",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "由数字社区平台设置的浏览器缓存文件，用于用户身份验证。",
              expiration: "会话",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "由数字社区平台设置的浏览器缓存文件，用于用户身份验证",
              expiration: "会话",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "此浏览器缓存文件用于区分人类和机器人，以保护网站免受自动化滥用。不收集任何个人数据。",
              expiration: "30 分钟",
            },
          ],
        },
      },
      {
        title: "分析",
        description:
          "分析类浏览器缓存文件有助于收集数据，使服务能够了解用户如何与特定服务交互。这些洞察有助于改进内容并开发更好的功能，从而提升用户体验。",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "名称",
            domain: "服务",
            description: "描述",
            expiration: "到期时间",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                '由 <a href="https://business.safety.google/adscookies/">Google Analytics</a> 设置的浏览器缓存文件',
              expiration: "12 天后过期",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                '由 <a href="https://business.safety.google/adscookies/">Google Analytics</a> 设置的浏览器缓存文件',
              expiration: "会话",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "启用与分析相关的存储，例如访问时长。";

export { translation, servicesLabel };
